export default __webpack_public_path__ + "static/mobile_15-2d0e861b8d67ea25d977472138afbcc2.webp";